<template>
    <div class="expert-detail-page" v-if="expert || loading || error">
        <achiTitle title="专家人才库" subtitle="汇聚各领域顶尖人才 助力科技创新发展"></achiTitle>

        <!-- 基本信息区 - 包含背景图 -->
        <div class="basic-info-container" v-if="expert || loading">
            <!-- 背景图 -->
            <div class="background-image"></div>

            <!-- 内容容器 -->
            <div class="basic-info-content">
                <!-- 加载状态 -->
                <el-skeleton :loading="loading" class="loading-skeleton">
                    <div class="basic-info-wrapper">
                        <!-- 左侧头像 -->
                        <div class="avatar-container">
                            <img :src="expert?.avatar" :alt="expert?.name" class="expert-avatar"
                                @error="handleAvatarError">
                        </div>

                        <!-- 右侧基本信息 - 上下结构 -->
                        <div class="info-right">
                            <!-- 专家名称 -->
                            <div class="name-container">
                                <h1 class="expert-name">{{ expert?.name }}</h1>
                                <span
                                    v-for="(title, index) in (expert?.titles || '').split(',').filter(t => t.trim())"
                                    :key="index"
                                    class="expert-title-tag">
                                    {{ title.trim() }}
                                </span>
                            </div>

                            <!-- 详细信息列表 -->
                            <div class="detail-info">
                                <div class="info-item">
                                    <span class="info-label">所属单位：</span>
                                    <span class="info-value"
                                        v-for="(institution, index) in expert.institutions"
                                        :key="index">
                                        {{ institution.name }}
                                    </span>
                                </div>

                                <div class="info-item">
                                    <span class="info-label">研究领域：</span>
                                    <div class="fields">
                                        <span v-for="(field, index) in expert?.researchFields.split(',')"
                                            :key="index"
                                            class="research-fields"
                                            effect="light">
                                            {{ field }}
                                        </span>
                                    </div>
                                </div>

                                <!-- <div class="info-item">
                                    <span class="info-label">专家ID：</span>
                                    <span class="info-value">{{ expert?.id }}</span>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </el-skeleton>
            </div>
        </div>

        <!-- 错误提示 -->
        <div v-if="error" class="error-container">
            <div class="error-icon">
                <i class="el-icon-warning-outline"></i>
            </div>
            <div class="error-desc">{{ error }}</div>
            <el-button type="primary" @click="loadDetailData()" style="margin-top: 20px;">
                重新加载
            </el-button>
        </div>

        <!-- 简介区 - 仅文本 -->
        <div class="introduction-container" v-if="expert && !loading && !error">
            <div class="introduction-content">
                <h2 class="section-title">个人简介</h2>
                <p class="intro-text">{{ expert.bio }}</p>
            </div>
        </div>

        <!-- 返回按钮 -->
        <!-- <div class="back-section" v-if="!loading && !error">
            <el-button type="default" @click="$router.go(-1)" icon="el-icon-arrow-left">
                返回列表
            </el-button>
        </div> -->
    </div>
</template>

<script>
import { Location } from '@element-plus/icons-vue';
import achiTitle from '../components/achievement/achi_title.vue';
import expertApi from '@/api/experts.js';
export default {
    name: 'ExpertDetail',
    components: {
        Location, achiTitle
    },
    props: {
        id: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            expert: null,
            loading: false,
            error: null,
            enterpriseName: "",
        };
    },
    computed: {

    },
    created() {
        this.loadDetailData();
    },
    methods: {
        async loadDetailData() {
            this.loading = true;
            this.error = null;
            try {
                // 请求专家数据
                this.expert = (await expertApi.getColumnById(this.id)).data
            } catch (err) {
                this.error = err.message || '数据加载失败';
                console.error('加载错误:', err);
            } finally {
                this.loading = false;
            }
        },
        findEnterpriseByExpert(enterprises, expertId) {
            if (!enterprises || !enterprises.length) return null;

            for (const enterprise of enterprises) {
                if (enterprise.experts && enterprise.experts.includes(expertId)) {
                    return enterprise.name;
                }
            }
            return null;
        },
        findUniversityByExpert(universities, expertId) {
            if (!universities || !universities.length) return null;

            for (const uni of universities) {
                if (uni.technicalExperts && uni.technicalExperts.includes(expertId)) {
                    return uni.name;
                }
            }
            return null;
        },
        handleAvatarError(e) {
            e.target.src =  require('@/assets/defaultImg/default-expert.png');
        }
    }
};
</script>

<style scoped>
/* 页面容器 */
.expert-detail-page {
    max-width: 70%;
    margin: 0 auto;
    padding: 20px;
    font-family: "Microsoft YaHei", sans-serif;
}

/* 1. 基本信息区 */
.basic-info-container {
    width: 100%;
    border-radius: 12px;
    overflow: hidden;
    margin-bottom: 30px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
    position: relative;
}

/* 背景图 */
.background-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url('https://ossfile.sytpre.com/2023/01/16/96a5f7f3-fac0-45e7-b8d8-293497bb3012.png') center center no-repeat;
    background-size: cover;
    opacity: 0.7;
    z-index: 1;
}

.basic-info-content {
    position: relative;
    z-index: 2;
    padding: 30px;
}

.basic-info-wrapper {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 30px;
}

/* 左侧头像 */
.avatar-container {
    flex-shrink: 0;
    object-fit:contain;
}

.expert-avatar {
    width: 180px;
    height: 180px;
    border-radius: 50%;
    object-fit: cover;
    border: 5px solid #fff;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

/* 右侧基本信息 */
.info-right {
    flex: 1;
    min-width: 300px;
}

/* 专家名称区域 */
.name-container {
    margin-bottom: 25px;
}

/* 头衔容器样式 - 让标签横向排列并留有间距 */
.titles-container {
    display: flex;
    gap: 8px;
    /* 标签之间的间距 */
    flex-wrap: wrap;
    /* 超出换行 */
    margin-top: 8px;
}

/* 蓝色风格的头衔标签样式 */
.expert-title-tag {
    background-color: #1677ff;
    /* 蚂蚁设计主蓝色，可自定义 */
    color: white;
    /* 文字白色 */
    padding: 4px 12px;
    /* 内边距：上下4px，左右12px */
    border-radius: 8px;
    /* 圆角，也可以用4px做直角矩形 */
    font-size: 16px;
    /* 字号 */
    line-height: 1.5;
    /* 行高 */
    white-space: nowrap;
    /* 防止文字换行 */
    margin-right: 5px;
}

/* 原有的名称样式（可选） */
.expert-name {
    font-size: 24px;
    font-weight: 600;
}

.research-fields {
    font-size: 16px;
    background-color: #e9e9e9;
    border-radius: 8px;
     margin: 0 0 8px 0;
    padding: 4px 12px;
    line-height: 1.5;
    white-space: nowrap;
}

.expert-title {
    font-size: 18px;
    color: #4a5568;
    background-color: #edf2f7;
    padding: 4px 12px;
    border-radius: 6px;
}

/* 详细信息列表 */
.detail-info {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.info-item {
    display: flex;
    align-items: flex-start;
}

.info-label {
    font-weight: 600;
    color: #4a5568;
    min-width: 100px;
    font-size: 16px;
}

.info-value {
    color: #1a202c;
    font-size: 16px;
}

.fields {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

/* 2. 简介区 */
.introduction-container {
    background-color: #fff;
    border-radius: 12px;
    padding: 30px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
    margin-bottom: 30px;
}

.section-title {
    font-size: 20px;
    font-weight: 600;
    color: #1a202c;
    margin: 0 0 20px 0;
    padding-bottom: 10px;
    border-bottom: 2px solid #e2e8f0;
}

.intro-text {
    line-height: 1.8;
    color: #4a5568;
    font-size: 16px;
    text-align: justify;
    margin: 0;
}

/* 错误提示 */
.error-container {
    text-align: center;
    padding: 60px 0;
    color: #666;
}

.error-icon {
    font-size: 40px;
    color: #FF6B6B;
    margin-bottom: 15px;
}

.error-desc {
    font-size: 16px;
    margin-bottom: 10px;
}

/* 返回按钮 */
.back-section {
    text-align: left;
    margin-top: 20px;
}

/* 加载骨架屏 */
.loading-skeleton {
    width: 100%;
}

/* 响应式调整 */
@media (max-width: 768px) {
    .basic-info-wrapper {
        flex-direction: column;
        text-align: center;
    }

    .info-item {
        flex-direction: column;
        align-items: center;
    }

    .info-label {
        margin-bottom: 5px;
        min-width: auto;
    }

    .fields {
        justify-content: center;
    }

    .expert-avatar {
        width: 150px;
        height: 150px;
    }

    .expert-name {
        font-size: 26px;
    }

    .basic-info-content {
        padding: 20px;
    }

    .introduction-container {
        padding: 20px;
    }
}
</style>